import _                    from 'lodash'
import moment               from 'moment'
import PropTypes            from 'prop-types'
import React                from 'react'
import { Button, Checkbox } from 'react-bootstrap'
import Confirm              from 'react-confirm-bootstrap'

import { SmartForm, InputSpecs } from 'alto-react-components/lib/components'
import { ClientForm            } from 'alto-react-kredit/lib/components'
import { Client                } from 'alto-react-kredit/lib/models'

import { collapsedGroupsSetting, hiddenGroupsSetting, hiddenFieldsSetting,
         requiredFieldsSetting } from 'alto-react-client-auth/lib/settings'

import './profile_form.sass'

# TODO: input spec should be a class, then it could implement things like addValidator

export default class ProfileForm extends SmartForm
  @contextTypes =
    auth:     PropTypes.object
    settings: PropTypes.object

  id:           'edit-profile-form'
  model:         Client
  defaultValues: ClientForm.defaultValues
  hiddenInputs:  ['clientId', 'cardId', 'chipId', 'status', 'comment']

  constructor: (props, context) ->
    super(props, context)

    @state.clearSensitiveData = false

  inputSpecs: ->
    if @_inputSpecs then @_inputSpecs
    else
      hiddenGroups    = hiddenGroupsSetting(@context.settings)
      collapsedGroups = collapsedGroupsSetting(@context.settings)
      hiddenFields    = hiddenFieldsSetting(@context.settings)
      requiredFields  = requiredFieldsSetting(@context.settings)

      inputSpecs = new InputSpecs(ClientForm.inputs)
      inputSpecs = inputSpecs.rejectInputs((spec) => spec.property in hiddenFields)
      inputSpecs = inputSpecs.rejectGroups((spec) => spec.name     in hiddenGroups)
      inputSpecs = inputSpecs.mapGroups((spec) =>
        _.assign({}, spec, collapsed: spec.name in collapsedGroups))

      requiredFields.forEach (field) =>
        inputSpecs = inputSpecs.addValidatorFor(field, 'notEmpty')

      @_inputSpecs = inputSpecs.updateSpecFor('personal.birthDate', (spec) ->
        disabledIf = (birthDate, client) ->
          lastUpdated = client.personal.birthDateUpdatedAt
          lastUpdated and lastUpdated.isAfter(moment().subtract(1, 'year'))

        _.assign({ disabledIf }, spec))

  buttons: ->
    <ul className="list-inline pull-right">
      <li className="clear-sensitive-data">
        <ul className="list-inline">
          <li>{@clearSensitiveDataCheckbox()}</li>
          <li>{@deleteAccountButton()}</li>
        </ul>
      </li>
      <li>{@submitButton()}</li>
      {<li>{@disableJuniorButton()}</li> if @props.disableJunior}
    </ul>

  submitButton: ->
    <Button id='edit-profile-submit' bsStyle='primary'
     disabled={not @state.valid} onClick={@submit.bind(@)}>
      Uložit změny
    </Button>

  disableJuniorButton: ->
    <Confirm title={"Ukončit mód Junior Bakarty"}
      body={"Skutečně chcete ukončit mód Junior Bakarty?"}
      confirmText="Ukončit"
      confirmBSStyle="warning"
      cancelText="Ponechat v módu Junior Bakarty"
      onConfirm={@props.disableJunior}>

      <Button id='disable-junior-button' bsStyle='warning'>
        Ukončit mód Junior Bakarty
      </Button>
    </Confirm>

  clearSensitiveDataCheckbox: ->
    <Checkbox value={@state.clearSensitiveData}
              onChange={(e) => @setState(clearSensitiveData: e.target.checked)}>
      Vymazat citlivé údaje
    </Checkbox>

  deleteAccountButton: ->
    if @state.clearSensitiveData
      body = <p>Skutečně chcete smazat svůj účet <strong>včetně všech citlivých údajů</strong>?</p>
    else
      body = <p>Skutečně chcete smazat svůj účet?</p>

    <Confirm title={"Smazat účet"}
      body={body}
      confirmText="Smazat"
      cancelText="Nemazat"
      onConfirm={=> @props.deleteAccount(@state.clearSensitiveData)}>

      <Button id='delete-profile-button' bsStyle='danger'>Smazat účet</Button>
    </Confirm>
